module.exports = __webpack_public_path__ + "img/horizontal_6_6_3009.953439de.png";